import React, { useEffect, useRef, useState } from "react";
import {
  GoogleMap,
  withScriptjs,
  withGoogleMap,
  Marker,
  Polyline,
} from "react-google-maps";
import { Card, Button, Grid } from "@mui/material";
import { mapStyle } from "./MapStyle";
import iconMap from "assets/images/driverImage.png";
import dropPin from 'assets/images/dropPin.png';
import originPin from 'assets/images/originPin.png';

const CommonMap = ({ paths, stops, driverPathDetails, status }) => {
  const driverLat = driverPathDetails?.location?.lat;
  const driverLng = driverPathDetails?.location?.lng;
  const polyLines = driverPathDetails?.location?.polylines?.trip?.points;
  const driverData = [{ lat: driverLat, lng: driverLng }];
  const icon1 = {
    url: iconMap,
    scaledSize: new window.google.maps.Size(40, 40),
    anchor: new window.google.maps.Point(20, 20),
    scale: 0.7,
  };

  const mapRef = useRef(null);
  const [center, setCenter] = useState({
    lat: (stops[0]?.lat + stops[1]?.lat) / 2,
    lng: (stops[0]?.lng + stops[1]?.lng) / 2,
  });

  // Fit bounds function
  const fitBounds = () => {
    if (status?.toLocaleLowerCase() !== 'rental') {
      const bounds = new window.google.maps.LatLngBounds();
      let boundPath = stops;
      if (driverLat && driverLng) {
        boundPath = [...boundPath, { lat: driverLat, lng: driverLng }];
      }
      boundPath.forEach(item => {
        bounds.extend(item);
      });
      mapRef.current.fitBounds(bounds);
    }
  };

  // Recenter map when stops or driver's location changes
  useEffect(() => {
    fitBounds();
  }, [stops, driverLat, driverLng]);

  const centerMap = () => {
    const newCenter = {
      lat: (stops[0]?.lat + stops[1]?.lat) / 2,
      lng: (stops[0]?.lng + stops[1]?.lng) / 2,
    };
    setCenter(newCenter);
    mapRef.current.panTo(newCenter);
  };

  return (
    <Card variant="outlined">
      <div className="gmapCont">
        <GoogleMap
          options={{
            styles: mapStyle,
            disableDefaultUI: true,
          }}
          ref={mapRef}
          defaultZoom={14}
          defaultCenter={center}
        >
          <Polyline
            path={polyLines ? polyLines : paths ? paths : []}
            options={{
              strokeColor: "#0F538D",
              strokeWeight: 6,
              defaultVisible: true,
            }}
          />
          {(status?.toLocaleLowerCase() === 'ongoing' || status?.toLocaleLowerCase() !== 'rental') && (
            <Marker
              icon={dropPin}
              position={polyLines ? polyLines[polyLines?.length - 1] : { lat: stops[1]?.lat, lng: stops[1]?.lng }}
            />
          )}

          {status?.toLocaleLowerCase() === 'dispatched' && (
            <Marker
              icon={dropPin}
              position={{ lat: stops[1]?.lat, lng: stops[1]?.lng }}
            />
          )}
          <>
            {/* <Marker
              icon={icon1}
              position={(driverData?.length > 0 && driverData[0]?.lat && driverData[0]?.lat !== null) ? driverData[0] : {}}
            /> */}
            {status && (
              <Marker
                icon={originPin}
                position={stops[0]}
              />
            )}
          </>
        </GoogleMap>
        <Grid item xs={6} className="justifyEnd">
          <Button className="centerButton" onClick={centerMap}>
            Re-Center
          </Button>
        </Grid>
      </div>
    </Card>
  );
};

export default withScriptjs(withGoogleMap(CommonMap));
